import { NavLink } from "react-router-dom"

// UI imports
import Table from "../../../../components/structure/table/table"
import Badge from "../../../../components/ui/badge/badge"
import { CheckIcon, XIcon } from "lucide-react"

const formatGBP = (value) => {
	const number = Number(value)
	if (!Number.isFinite(number)) return "-"
	return number.toLocaleString("en-GB", {
		style: "currency",
		currency: "GBP",
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	})
}

// Returns the bookings table for the masters 2027 page
export default function Bookings({ bookings }) {
	const totals = bookings.reduce(
		(acc, booking) => {
			const totalCosts = Number(booking.margins?.supplier_invoices)
			const totalMargin = Number(booking.margins?.profit)
			const groupSize = Number(booking.group_size) || 0

			if (Number.isFinite(totalCosts)) acc.totalCosts += totalCosts
			if (Number.isFinite(totalMargin)) acc.totalMargin += totalMargin

			if (Number.isFinite(totalMargin) && groupSize > 0) {
				acc.avgMarginSum += totalMargin / groupSize
				acc.avgMarginCount += 1
			}

			return acc
		},
		{ totalCosts: 0, totalMargin: 0, avgMarginSum: 0, avgMarginCount: 0 },
	)

	const avgOfAverages = totals.avgMarginCount > 0 ? totals.avgMarginSum / totals.avgMarginCount : null

	return (
		<Table
			className="bookings-table"
			headings={["Booking Reference", "Agent", "Lead Client", "Group Status", "Total Costs", "Total Margin", "Avg Margin / Head", ""]}>
			{bookings.length > 0 ? (
				<>
					{bookings.map((booking) => {
						const totalCosts = Number(booking.margins?.supplier_invoices)
						const totalMargin = Number(booking.margins?.profit)
						const groupSize = Number(booking.group_size) || 0
						const avgMarginPerHead = Number.isFinite(totalMargin) && groupSize > 0 ? totalMargin / groupSize : null

						return (
							<tr key={booking.bookingID}>
								<td style={{ width: "220px", whiteSpace: "nowrap" }}>
									<NavLink to={`/booking/${booking.bookingID}`}>
										{booking.reference}
										{!booking.reference && <small className="no-value">No reference</small>}
									</NavLink>
								</td>
								<td>
									{booking.agent?.name}
									{!booking.agent?.name && <small className="no-value">No agent assigned</small>}
								</td>
								<td>
									<NavLink to={`/client/${booking.client.clientID}`}>
										{booking.client?.name}
										{!booking.client?.name && <small className="no-value">No name set</small>}
									</NavLink>
								</td>
								<td>
									<div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
										{booking.complete && (
											<>
												<CheckIcon
													size={19}
													color="#22b229"
												/>

												<div>
													<Badge
														type="POSITIVE"
														label={`${booking.valid_group_names}/${booking.group_size}`}
													/>
												</div>
											</>
										)}

										{!booking.complete && (
											<>
												<XIcon
													size={19}
													color="#d3423d"
												/>

												<div>
													<Badge
														type="NEGATIVE"
														label={`${booking.valid_group_names}/${booking.group_size}`}
													/>
												</div>
											</>
										)}
									</div>
								</td>
								<td>{Number.isFinite(totalCosts) ? formatGBP(totalCosts) : <small className="no-value">-</small>}</td>
								<td>{Number.isFinite(totalMargin) ? formatGBP(totalMargin) : <small className="no-value">-</small>}</td>
								<td>{avgMarginPerHead !== null ? formatGBP(avgMarginPerHead) : <small className="no-value">-</small>}</td>
								<td
									className="is-button"
									style={{ textAlign: "right", width: "1%", whiteSpace: "nowrap" }}>
									<div className="condensed-buttons">
										<NavLink to={`/booking/${booking.bookingID}`}>View booking</NavLink>
										<NavLink
											to={`/booking/${booking.bookingID}`}
											target="_blank">
											View in new tab
										</NavLink>
									</div>
								</td>
							</tr>
						)
					})}
					<tr style={{ fontWeight: 600 }}>
						<td style={{ width: "220px", whiteSpace: "nowrap" }}>Totals</td>
						<td />
						<td />
						<td />
						<td>{formatGBP(totals.totalCosts)}</td>
						<td>{formatGBP(totals.totalMargin)}</td>
						<td>{avgOfAverages !== null ? formatGBP(avgOfAverages) : <small className="no-value">-</small>}</td>
						<td />
					</tr>
				</>
			) : (
				<tr>
					<td colSpan={8}>
						<small>No bookings found for The Masters 2027 event.</small>
					</td>
				</tr>
			)}
		</Table>
	)
}
